import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5e2f25f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "row loader-filter-row"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "da-skeleton-loader loader-text" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "da-skeleton-loader loader-dropdown" }, null, -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "da-skeleton-loader loader-header-1" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { style: {"border-color":"#EEE","margin-top":"21px","margin-bottom":"25px"} }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "da-skeleton-loader loader-text" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "col loader-list" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"da-skeleton-loader loader-avatar\" data-v-5e2f25f2></div><div class=\"col\" data-v-5e2f25f2><div class=\"da-skeleton-loader loader-header-2\" data-v-5e2f25f2></div><div class=\"da-skeleton-loader loader-text\" data-v-5e2f25f2></div><div class=\"da-skeleton-loader loader-text-small\" data-v-5e2f25f2></div></div><div data-v-5e2f25f2><div class=\"da-skeleton-loader loader-button\" data-v-5e2f25f2></div><div style=\"text-align:center;\" data-v-5e2f25f2><div class=\"da-skeleton-loader loader-text-small\" data-v-5e2f25f2></div></div></div>", 3)
const _hoisted_13 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.showFilters)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (ddlLoader) => {
            return _createElementVNode("div", {
              class: "col",
              key: ddlLoader
            }, _hoisted_4)
          }), 64))
        ]))
      : _createCommentVNode("", true),
    _hoisted_5,
    _hoisted_6,
    _hoisted_7,
    _hoisted_8,
    _createElementVNode("div", _hoisted_9, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (rtItem) => {
        return _createElementVNode("div", {
          class: "row loader-list-item",
          key: rtItem
        }, _hoisted_13)
      }), 64))
    ])
  ]))
}